<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control border-0"
                        :options="optionEmployee"
                        v-model="search.employee"
                        :customLabel="employeeLabel"
                        select-label=""
                        deselectLabel=""
                        placeholder="พนักงาน"
                        track-by="id">
                    </multiselect>
                    <b-select :options="optionDepartment" v-model="search.department"></b-select>
                    &nbsp;&nbsp;
                    <b-select :options="employee_type" v-model="search.employee_type"></b-select>
                    &nbsp;&nbsp;
                    <date-picker
                            v-model="search.date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en"
                            placeholder="วันที่ปรับ" >
                    </date-picker>
                    &nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchSalaryHistory">
                        <icon name="search"></icon> ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ประเภทพนักงาน</th>
                    <th scope="col">แผนก</th>
                    <th scope="col">ปรับเป็น</th>
                    <th scope="col">วัน/เดือน/ปี ที่ปรับ</th>
                    <th scope="col">ผู้ปรับ</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in salaryHistoryList">
                    <tr v-for="info in data.rate_salary_employee">
                        <td>{{data.employee_no}}</td>
                        <td>{{data.name}}</td>
                        <td>
                            <template v-if="data.occupation && data.occupation.type">
                                {{data.occupation.type.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.occupation && data.occupation.position">
                                {{data.occupation.position.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.rate_salary_employee.length > 0">
                                {{info.salary}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.rate_salary_employee.length > 0">
                                {{info.created_at | moment("DD/MM/YYYY")}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.rate_salary_employee.length > 0">
                                <span v-if="info.user">{{info.user.name}}</span>
                            </template>
                            <template v-else>-</template>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="salaryHistoryList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSalaryHistory">

            </vue-pagination>
        </div>
        <!--<pre class="alert alert-primary">{{salaryHistoryList}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'
    import Multiselect from "vue-multiselect";
    import VuePagination from "../../../Pagination";
    import {
        canViewSuperAdmin
    } from "../../../../util/Permissions";
    export default {
        components: {
            VuePagination,
            DatePicker,
            Multiselect,
        },
        name: "rate-salary",
        created(){
            this.$store.dispatch("RateSalaryHistory/setRateSalaryHistory")
            this.$store.dispatch("RateSalaryHistory/clearSearch");
            this.getEmployeeAll();
            this.getDepartmentAll();
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                salaryHistoryList:state=>{
                    return state.RateSalaryHistory.salaryHistoryList;
                },
                search:state =>{
                    return state.RateSalaryHistory.search;
                },
                dataPaginate:state=>{
                    return state.RateSalaryHistory.dataPaginate;
                },
                optionDepartment : state=>{
                    return [
                        {
                            value: "",
                            text: "ค้นหาสถานะ"
                        },
                        ...state.Common.position.map(status => ({
                            value: status.id,
                            text: status.name
                        }))
                    ]
                }
            })
        },
        data(){
            return{
                event_submit: false,
                optionEmployee : [],
                employee_type : [
                    {
                        value: "",
                        text: "ค้นหาประเภทพนักงาน"
                    },
                    {
                        value: 1,
                        text: "ประจำ"
                    },
                    {
                        value: 2,
                        text: "รายวัน"
                    },
                ]
            }
        },
        methods:{
            getDepartmentAll(){
              this.$store.dispatch("Common/setPosition");
            },
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            getEmployeeAll(){
                this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                    this.optionEmployee = res;
                })
            },
            searchSalaryHistory(){
                this.event_submit = true;
                let data = {
                    employee_id : this.search.employee ? this.search.employee.id : '',
                    employee_type : this.search.employee_type,
                    department : this.search.department,
                    date : this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : null,
                };
                this.$store.dispatch("RateSalaryHistory/search",data)
            },
            getSalaryHistory(){
                const page = this.dataPaginate.current_page;

                //change date format
                if(this.search.created_at){
                    this.search.created_at = moment(this.search.created_at).format("YYYY-MM-DD");
                }else{
                    this.search.created_at = "";
                }

                let data = {
                    page : page,
                    employee_type: this.search.employee_type,
                    department: this.search.department,
                    name: this.search.name,
                    created_at: this.search.created_at,
                }

                //paginate search
                if(this.event_submit){
                    this.$store.dispatch('RateSalaryHistory/search',data)
                }
                //paginate get data
                else{
                    this.$store.dispatch('RateSalaryHistory/setRateSalaryHistory',page)
                }

            }
        }
    }
</script>

<style scoped>

</style>
